import React, { useEffect, useState } from 'react';
import styled from "@emotion/styled";
import { colors } from 'src/theme';
import { Flex } from 'src/components';

const Container = styled.div({
  borderRadius: '12px',
  padding: '4px',
  backgroundColor: colors.background7,
});

const OptionContainer = styled(Flex)({
  position: 'relative'
});

const Option = styled.div((props: { isSelected: boolean }) => ({
  color: props.isSelected ? colors.text7 : colors.text1,
  cursor: 'pointer',
  textAlign: 'center' as const,
  padding: '8px 14px',
  flex: 1,
  zIndex: 1,
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '20px'
}));

const Glider = styled.div((props: { position: number, count: number}) => ({
  position: 'absolute' as const,
  top: 0,
  bottom: 0,
  left: 0,
  backgroundColor: colors.primary,
  width: `${100 / props.count}%`,
  height: '100%',
  zIndex: 0,
  transition: 'transform 0.3s ease',
  borderRadius: '8px',
  transform: `translateX(${props.position * 100}%)`

}));

interface RadioOption {
  value: string;
  label: string;
}

interface RadioButtonGroupProps {
  options: RadioOption[];
  value?: string;
  onChange?: (selectedOption: string) => void;
  className?: string;
}

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({ options, value = options[0].value, onChange, className }) => {

  const [selectedOption, setSelectedOption] = useState<string | undefined>(value);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  // Funkcija za ažuriranje stanja
  const handleOptionChange = (optionValue: string) => {
    setSelectedOption(optionValue);
    if (onChange) onChange(optionValue); // Pozivamo onChange prop funkciju sa izabranom opcijom
  };

  const selectedIndex = options.findIndex(option => option.value === selectedOption);

  return (
    <Container className={className}>
      <OptionContainer>
        {options.map((option) => (
          <Option
            key={option.value}
            onClick={() => handleOptionChange(option.value)}
            isSelected={selectedOption === option.value}
          >
            {option.label}
          </Option>
        ))}
        <Glider position={selectedIndex} count={options.length} />
      </OptionContainer>
    </Container>
  );
};
